import type { BlankEnum, SampleVariant, UnitEnum } from 'api';

import { AluMaterialSampleBreakdown } from '../AluMaterialSampleBreakdown/AluMaterialSampleBreakdown';
import { GenericMaterialSampleBreakdown } from '../GenericMaterialSampleBreakdown/GenericMaterialSampleBreakdown';
import { PetFlakeMaterialSampleBreakdown } from '../PetFlakeMaterialSampleBreakdown/PetFlakeMaterialSampleBreakdown';
import { PetMaterialSampleBreakdown } from '../PetMaterialSampleBreakdown/PetMaterialSampleBreakdown';
import { TaintTaborMaterialSampleBreakdown } from '../TaintTaborMaterialSampleBreakdown/TaintTaborMaterialSampleBreakdown';
import { ZorbaMaterialSampleBreakdown } from '../ZorbaMaterialSampleBreakdown/ZorbaMaterialSampleBreakdown';

export type Item = {
  label: string;
  value: string;
  unit: UnitEnum | BlankEnum;
  unit_display: string;
};

export const MaterialSampleBreakdown = ({
  items,
  variant,
  precision = 1,
}: {
  items: Item[];
  variant?: SampleVariant;
  precision?: number;
}) => {
  if (!variant) {
    return <GenericMaterialSampleBreakdown items={items} precision={precision} />;
  }
  if (variant === 'petFlake') {
    const records = items.reduce<Record<string, Item>>((acc, item) => {
      acc[item.label] = item;
      return acc;
    }, {});
    return <PetFlakeMaterialSampleBreakdown breakdown={records} precision={precision} />;
  }

  const breakdown = items.reduce<Record<string, number>>((acc, item) => {
    acc[item.label] = Number(item.value);
    return acc;
  }, {});

  const weight = items.reduce<number>((acc, item) => acc + Number(item.value), 0);

  return (
    <>
      {variant === 'alu' && (
        <AluMaterialSampleBreakdown totalWeight={weight} breakdown={breakdown} precision={precision} />
      )}
      {variant === 'pet' && (
        <PetMaterialSampleBreakdown totalWeight={weight} breakdown={breakdown} precision={precision} />
      )}
      {variant === 'taintTabor' && (
        <TaintTaborMaterialSampleBreakdown totalWeight={weight} breakdown={breakdown} precision={precision} />
      )}
      {variant === 'zorba' && (
        <ZorbaMaterialSampleBreakdown totalWeight={weight} breakdown={breakdown} precision={precision} />
      )}
    </>
  );
};
